/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable import/no-unresolved */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { selectAuth } from '@/store/selectors';
import { setAlert } from '@/store/slices/alert';
import { closeModal, openModal } from '@/store/slices/modal';
import { handleApiError } from '@/utils/helpers';
import { clearDeliveryDetails } from '@/store/slices/delivery';
import { updateChangeGiven, updateChangeSaved } from '@/store/slices/order';

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const fetcher = (url: any, paymentObj: any) => {
  const response = axios({
    method: 'post',
    url: `https://${url}/api/method/oyasync_integrations.oyasync_integrations.api.pos_app.pos_app.submit_invoice`,
    data: {
      use_change: paymentObj.use_change,
      save_change: paymentObj.save_change,
      saved_change: paymentObj.saved_change,
      change_collected: paymentObj.change_collected,
      data: { ...paymentObj.payments },
    },
    withCredentials: true,
  })
    .then((data) => data)
    .catch((error) => error);

  return response;
};

// eslint-disable-next-line import/prefer-default-export
export const useSubmitPayment = () => {
  const { url } = useSelector(selectAuth);

  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const handleSuccess = () => {
    dispatch(
      setAlert({ type: 'success', message: 'Payment submitted successfully' }),
    );
    dispatch(closeModal({ type: 'submitPayment' }));
    dispatch(openModal({ type: 'printInvoice' }));
  };

  const handleError = (message: string) => {
    dispatch(setAlert({ type: 'error', message }));
  };

  const mutate = useMutation((paymentObj: any) => fetcher(url, paymentObj), {
    onSettled: (data) => {
      if (!data.data) {
        const errorMessage = handleApiError(data);
        handleError(errorMessage);
      } else if (data.data) {
        const changeGiven = data?.data?.message?.change_given;
        const changeSaved = data?.data?.message?.customer_balance;
        dispatch(updateChangeSaved(changeSaved));
        dispatch(updateChangeGiven(changeGiven));
        handleSuccess();
        setTimeout(() => {
          dispatch(clearDeliveryDetails());
        }, 4000);
        queryClient.invalidateQueries(['table-groups', 'orders', 'KOT']);
      }
    },
    onError: () => handleError('An Error Occured. Contact Administration'),
  });

  return mutate;
};
